// extracted by mini-css-extract-plugin
export default {"main":"FilterByStringItem_main__oFBD8","title":"FilterByStringItem_title__kg+h5","amount":"FilterByStringItem_amount__vhkRd"};